"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const immer_1 = require("immer");
const addReviewsReceived_1 = tslib_1.__importDefault(require("./addReviewsReceived"));
function applyPeerReviewReceivedCommand(command, content, states, allStateInteractions) {
    try {
        const events = [];
        const stateInteractions = [];
        const updatedStates = immer_1.produce(states, draftStates => {
            addReviewsReceived_1.default(command, content, draftStates, allStateInteractions);
        });
        return { states: updatedStates, events, stateInteractions, enrolments: [] };
    }
    catch (error) {
        throw new Error('Error in applyPeerReviewReceiveCommand ' + error);
    }
}
exports.applyPeerReviewReceivedCommand = applyPeerReviewReceivedCommand;
//# sourceMappingURL=applyPeerReviewReceivedCommand.js.map